/* eslint-disable check-file/filename-blocklist */
import { CONTEXT_PATH, SPACE_OVERVIEW, PAGE_DIFF_BY_VERSION } from '@confluence/named-routes';

import type {
	FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment as FeedComment,
	FeedContentQuery_feed_nodes_summaryLineUpdate as SummaryLineUpdate,
	FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit as SummaryLineUpdate_Edit,
	FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment as SummaryLineUpdate_Comment,
} from '../__types__/FeedContentQuery';
import { FeedEventType } from '../__types__/FeedContentQuery';

type ContentLinkContent = {
	links: {
		webui: string | null;
	} | null;
} | null;
export const getContentLink = (content: ContentLinkContent): string => {
	if (!content?.links?.webui) {
		return '';
	}
	return `${CONTEXT_PATH}${content?.links?.webui}`;
};

export const getCommentLink = (comment: FeedComment): string => {
	if (!comment?.links?.webui) {
		return '';
	}
	return `${CONTEXT_PATH}${comment?.links?.webui}`;
};

type SpaceLinkContent = {
	space: {
		alias?: string | null;
		key: string | null;
	} | null;
} | null;
export const getSpaceLink = (
	content: SpaceLinkContent,
	isSpaceAliasFFEnabled?: boolean,
): string => {
	const spaceKey = content?.space?.key;
	if (!spaceKey) {
		return '';
	}

	const spaceAlias =
		isSpaceAliasFFEnabled && !!content?.space?.alias ? content.space.alias : spaceKey;

	return SPACE_OVERVIEW.toUrl({ spaceKey: spaceAlias });
};

type User = {
	accountId: string | null;
};
export const getUserAccountId = (user?: User | {} | null): string | null => {
	if (user) {
		return 'accountId' in user ? user.accountId : null;
	}
	return null;
};

export const getLinkForSummaryLinkUpdate = (
	update: SummaryLineUpdate,
	contentUrl: string,
	contentId: string,
): string => {
	const type = update.type;
	if (type === 'COMMENT') {
		const commentLink = (update as SummaryLineUpdate_Comment).comment?.links.webui;
		if (commentLink) {
			return `${CONTEXT_PATH}${commentLink}`;
		} else {
			return '';
		}
	}

	if (type === 'CREATE') {
		return contentUrl;
	}

	if (type === 'EDIT') {
		const version = (update as SummaryLineUpdate_Edit).version;
		const params = {
			query: {
				pageId: contentId,
				selectedPageVersions: [version, version - 1],
			},
		};
		return PAGE_DIFF_BY_VERSION.toUrl({}, params);
	}

	return '';
};

const supportedEventTypes = [
	FeedEventType.COMMENT,
	FeedEventType.CREATE,
	FeedEventType.EDIT,
	FeedEventType.EDITLIVE,
	FeedEventType.PUBLISHLIVE,
];
export const isSupportedEvent = (type: FeedEventType): boolean => {
	return supportedEventTypes.includes(type);
};

export const fadeInAnimation = `
  @keyframes fadeIn {
    0% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
    }
  }

  animation: fadeIn 200ms ease-in-out;
`;
